import { isEqual } from 'lodash'

export function replaceItemAtIndex<T>(arr: T[], index: number, newValue: T): T[] {
    return [...arr.slice(0, index), newValue, ...arr.slice(index + 1)]
}

export function removeItemAtIndex<T>(arr: T[], index: number): T[] {
    return [...arr.slice(0, index), ...arr.slice(index + 1)]
}

export function insertItemAtIndex<T>(arr: T[], index: number, newItem: T): T[] {
    return [...arr.slice(0, index), newItem, ...arr.slice(index)]
}

export const getCommonStringsOfArrays = (firstArray: string[], secondArray: string[]): string[] => {
    return firstArray.filter((element) => secondArray.includes(element))
}

export const getDifferentsStringsOfArrays = (firstArray: string[], secondArray: string[]): string[] => {
    return firstArray.filter((element) => !secondArray.includes(element))
}

export const getRandomItem = <T>(arr: T[]): T => {
    return arr[Math.floor(Math.random() * arr.length)]
}

export const isEqualArraysByIds = <T extends object>(
    arrayA: T[],
    arrayB: T[],
    idGetter: (item: T, index: number) => string
): boolean => {
    if (arrayA.length !== arrayB.length) return false

    const idsA = arrayA.map((item, idx) => idGetter(item, idx))
    const idsB = arrayB.map((item, idx) => idGetter(item, idx))

    return isEqual(idsA.sort(), idsB.sort())
}

export function safeExtractIds<T extends { id: string }>(items: T[] | undefined): string[] {
    if (!items || !Array.isArray(items)) return []
    return [...new Set(items.map((item) => item.id).filter(Boolean))]
}
